// extracted by mini-css-extract-plugin
export default {"bodyContainer":"ReleaseNotes_bodyContainer__pQzt5","leftNavigation":"ReleaseNotes_leftNavigation__vWNZ3","rightContent":"ReleaseNotes_rightContent__lAqTZ"};